<template>
     <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
           PAGO DECLINADO
          </h4>
        </template>
        <div class="con-form">
            <p>Los pagos declinados son realizados con criterios del sistema Visa/MasterCard y no interviene nuestro sistema administrativo. Favor de comunicarse con su banco emisor.</p>
            <p>Los pagos son protegidos por medio del sistema 3D Secure, que requiere que el cliente valide por medio de la contraseña que recibe en su celular, dicha operación de pago. </p>
            <p>1.- Si el cliente no recibe dicha contraseña en su celular puede deberse a que no tiene actualizado su número telefónico y por tanto debe realizar dicho trámite ante su banco emisor. </p>
            <p>2.- Si el banco tiene actualizado su número telefónico y aun así no recibe la contraseña, entonces debe llamar a su compañía de telefonía para validar que no exista algún tipo de bloqueo para recibir dicho mensaje y en su caso pedir el desbloqueo. </p>
        </div>
      </vs-dialog>
</template>

<script>
export default {
    props:[
      'value'
    ],
    data () {
        return {
            active: false,
        }
    },
    watch: {
        value (val) {
            this.active = val
        },       
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>